import * as React from "react";
import * as ReactDOM from "react-dom";
import Button from '@material/react-button';
import { Trans } from 'react-i18next';
import { CREATE_LAB_MIN_WINDOW_WIDTH, CREATE_LAB_MIN_WINDOW_HEIGHT } from "../../_config/Consts";
import AwareComponent from '@af-common/Common/_components/AwareComponent';
import PromptContainer, { PromptMessageTypes } from '@af-common/Common/_containers/PromptContainer';

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

type State = {
	isOpen: boolean,
	width: number,
	height: number
}
type Props = {}

export default class SmallDeviceMessageDialog extends AwareComponent<Props, State> {
	state = {
		isOpen: false,
		width: 0,
		height: 0
	} as State

	constructor(props: Props) {
	  super(props);
	  this.state = { isOpen: false, width: 0, height: 0 };
	  this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	componentDidUpdate(prevProps:Props, prevState:State){
		if(this.stateChanged(prevState, 'width', 'height')){
			if(this.state.width < CREATE_LAB_MIN_WINDOW_WIDTH || this.state.height < CREATE_LAB_MIN_WINDOW_HEIGHT) {
				this.setState({isOpen: true})
			} else {
				this.setState({isOpen: false})
			}
		}
	}

	private updateWindowDimensions() {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}

	private stopMouseEvent = (e:React.MouseEvent) => {
		e.stopPropagation();
	}

	render() { 
		let closeAction = "";
		return <>
			<PromptContainer
				opened={this.state.isOpen}
				title={<T>Warning</T>}
				message={<T>Oh no! Your window is too small for the lab. It needs to be at least {String(CREATE_LAB_MIN_WINDOW_WIDTH)}px x {String(CREATE_LAB_MIN_WINDOW_HEIGHT)}px</T>}
				dismissible={false}
				showIcon={true}
				messageType={PromptMessageTypes.PromptMessageTypeWarning}
			/>
			{this.state.isOpen && <div className="small-device-document-overlay"></div>}
		</>
	}
}